/* import __COLOCATED_TEMPLATE__ from './save-button-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();